import React from 'react';
import DateTimeDisplay from '../DateTimeDisplay';
import { useCountdown } from '../../hooks/countdown';

const ExpiredNotice = () => {
  return (
    <div className="expired-notice">
      <span>Expired!!!</span>
    </div>
  );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="show-counter"
		style={{
			gap: "16px",
			display: "flex"
		}}
		>
        <DateTimeDisplay value={days} type={'Days'} isDanger={false} />
        <p
			style={{
				paddingTop: "12px"
			}}
			>:</p>
        <DateTimeDisplay value={hours} type={'Hours'} isDanger={false} />
        <p
			style={{
				paddingTop: "12px"
			}}
			>:</p>
        <DateTimeDisplay value={minutes} type={'Mins'} isDanger={false} />
        <p
			style={{
				paddingTop: "12px"
			}}
			>:</p>
        <DateTimeDisplay value={seconds} type={'Seconds'} isDanger={false} />
    </div>
  );
};

const CountdownTimer = ({ targetDate }) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return <ExpiredNotice />;
  } else {
    return (
      <ShowCounter
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
      />
    );
  }
};

export default CountdownTimer;
